import { Platform } from 'react-native';

export default Platform.OS === 'android' ? {
  bold: {
    fontFamily: "OpenSans-Bold"
  },
  light: {
    fontFamily: "OpenSans-Light"
  },
  regular: {
    fontFamily: "OpenSans-Regular"
  }
} : {
  bold: {
    fontWeight: "700"
  },
  light: {
    fontWeight: "300"
  },
  regular: {
    fontWeight: "400"
  }
};
